import {Component} from 'react';
import PropTypes from 'prop-types';
import {Form, Header, Segment} from 'semantic-ui-react';
import ComparableSummaryContainer from 'components/ComparableSummaryContainer';
import {DisclaimerText} from 'components/DisclaimerText';
import EditableTitle from 'components/EditableTitle';
import FeaturedComparableContainer from 'components/FeaturedComparableContainer';

export default class CustomiseComparableListings extends Component {
  static propTypes = {
    section: PropTypes.object.isRequired,
    reportType: PropTypes.string.isRequired,
    selectedComparableListings: PropTypes.arrayOf(PropTypes.number).isRequired,
    featuredProperties: PropTypes.arrayOf(PropTypes.number).isRequired,
    updateSectionValue: PropTypes.func.isRequired,
    updatePreferences: PropTypes.func.isRequired,
  };

  updateReportTitle = (data) => {
    const {reportType, updateSectionValue, updatePreferences} = this.props;

    updateSectionValue(data.title, 'title');
    updatePreferences({'comparableListings.sectionData.title': data.title}, reportType);
  };

  render() {
    const {section, featuredProperties, selectedComparableListings} = this.props;
    return (
      <div className="comparable-listings">
        <Header as="h2" className="section-type" style={{fontWeight: 'bold'}} disabled>Comparable Listings</Header>
        <Segment style={{padding: '30px'}}>
          <Header as="h3">
            <span className="disabled">Title</span>
            <DisclaimerText/>
          </Header>
          <Form className="sectionData">
            <Form.Group inline>
              <EditableTitle
                  onUpdateData={this.updateReportTitle}
                  title={section.sectionData.title}
                  isEnabled={true}
                  width="50%"
                  maxLength={32}/>
            </Form.Group>
          </Form>
          <div className="featured-properties">
            {featuredProperties.filter((id) => id).map(id => (
              <FeaturedComparableContainer propertyId={id} key={id} comparableType="listings"/>
            ))}
          </div>
          <div className="comparables">
            {selectedComparableListings.filter((id) => id).map(id => (
              <ComparableSummaryContainer propertyId={id} pageContext="Comparable Listings" key={id}/>
            ))}
          </div>
        </Segment>
      </div>
    );
  }
}